import { useState } from "react";

import { NavbarHeader } from "./navbar-header";
import { NavbarMobile } from "./navbar-mobile";

export function AppNavbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <NavbarHeader open={open} setOpen={setOpen} />
      <NavbarMobile open={open} setOpen={setOpen} />
    </>
  );
}
